export default {
  TITLE: `Expiration d'attributs`,
  SUMMARY: `Ton gestionnaire te demande de confirmer que tu as pris connaissance des rappels envoyés concernant l'expiration de tes attributs:`,
  PRIMARY_ACTION: `J'ai pris connaissance des rappels envoyés`,
  ATTRIBUTE: `Attribut`,
  EXPIRATIONDATE: `Date d'expiration`,
  REMINDERDATE: `Date du rappel`
}
